import type { HttpTransport } from "@common/api/transport";
import type { UserColor } from "@common/types/apiTypes";

export const createColorsApi = (http: HttpTransport) => ({
  fetchColors: () => http.get<UserColor[]>("/api/colors")
});
